import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=418cc5ef"
import script from "./DashboardHeader.vue?vue&type=script&lang=js"
export * from "./DashboardHeader.vue?vue&type=script&lang=js"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=418cc5ef&prod&lang=scss"
import style1 from "./DashboardHeader.vue?vue&type=style&index=1&id=418cc5ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports